import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

const getBankTransferSettings = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_BANK_TRANSFER_SETTINGS,
      "GET",
      { "Content-Type": "application/json" }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const saveBankTransferSettings = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_BANK_TRANSFER_SETTINGS,
      "PUT",
      { "Content-Type": "application/json" },
      JSON.stringify(payload)
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const confirmBankTransfer = (orderId, adminNote = "") => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_BANK_TRANSFER_CONFIRM + `/${orderId}`,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify({ adminNote })
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const bankTransferApiService = {
  getBankTransferSettings,
  saveBankTransferSettings,
  confirmBankTransfer,
};
